import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4 stats-box" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { style: {"max-width":"290px","margin":"auto","margin-top":"-32px","margin-bottom":"-19px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"d-flex justify-content-between flex-wrap gap-2\"><div><div class=\"d-flex\"><span>Total Customers</span><span class=\"count up\">+5.4</span></div><h3 class=\"fs-20 mt-1 mb-0\">1,528</h3></div><span class=\"fs-12\">Last 7 days</span></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isClient)
          ? (_openBlock(), _createBlock(_component_apexchart, {
              key: 0,
              type: "line",
              height: "140",
              options: _ctx.totalCustomers,
              series: _ctx.customers
            }, null, 8, ["options", "series"]))
          : _createCommentVNode("", true)
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "d-flex justify-content-between flex-wrap gap-2" }, [
        _createElementVNode("span", { class: "fs-12" }, "1 June"),
        _createElementVNode("span", { class: "fs-12" }, "7 June")
      ], -1))
    ])
  ]))
}